import statsCode from './stats-worker'
import timeseries = require('timeseries-analysis')

type ImageInterval = (Date | number)[]

export default class Stats {

	worker: Worker;
	context: Window;

	static maxSeriesLen = 20
	series: ImageInterval[] = []
	lastTime: Date = new Date(-1)
	lastTripTime = -1
	baseline = -1

	onDecodingLag: () => void;
	onBadCond: () => void;
	onGoodCond: () => void;

	constructor(context: Window) {

		this.context = context

		let blob = new Blob([statsCode])
		let blobURL = this.context['URL'].createObjectURL(blob)
		this.worker = new Worker(blobURL)

		this.worker.onmessage = (ev: MessageEvent) => {
			let status = ev.data.status
			switch (status) {
				case 'DECODING_LAG':
					this.onDecodingLag()
					break

				default:
					break
			}
		}
	}

	logRecvNALU(size: number) {

		this.worker.postMessage({
			command: 'RECEIVE_NALU',
			payload: {
				inbound_size: size
			}
		})
	}


	logDrawVideoFrame() {
		this.worker.postMessage({
			command: 'DRAW_VIDEO_FRAME',
		})
	}
	
	logRecvImage(size: number) {
		let time = this.context.performance.now()
		
		this.worker.postMessage({
			command: 'RECEIVE_IMAGE',
			payload: {
				inbound_size: size
			}
		})
	}
	
	logDecoderStart(scaleFactor: number = 1) {
		this.worker.postMessage({
			command: 'DECODER_START',
			payload: {
				scaleFactor
			}
		})
	}

	close() {
		this.worker.postMessage({
			command: 'CLOSE'
		})
	}

	logRTT(timeDiff: number) {
		this.baseline = timeDiff
	}

	logImageArrival(ts: number) {
		let arrivalTime = new Date(ts)

		if (this.lastTime.valueOf() == -1) {
			this.lastTime = arrivalTime
			return
		}

		let delta = arrivalTime.valueOf() - this.lastTime.valueOf()
		this.lastTime = arrivalTime
		this.series.push([new Date(arrivalTime.toDateString()), delta])
		if (this.series.length > Stats.maxSeriesLen) {
			this.series.shift()
		}
	}

	logImageHalt() {
		// reset time
		this.lastTime = new Date(-1)
		let ts = new timeseries.main(this.series)
		let mean = ts.mean()
		let std = ts.stdev()
		
		if (mean > this.baseline && std > 0.3 * this.baseline) {
			this.onBadCond()
			this.baseline = mean
		} else if (mean > 160) {
			this.onBadCond()
			this.baseline = mean
		} else if (mean < this.baseline * 0.6) {
			this.onGoodCond()
		} else {
			return
		}
	}

	getSeries() {
		return new timeseries.main(this.series)
	}

}